import { render, staticRenderFns } from "./AudabridgeSubmitDocumentsModal.vue?vue&type=template&id=2ddf0393"
import script from "./AudabridgeSubmitDocumentsModal.vue?vue&type=script&lang=js"
export * from "./AudabridgeSubmitDocumentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports